import React, { useState } from "react";
import { Product } from "../types/types";

const Products: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [name, setName] = useState("");
  const [price, setPrice] = useState<number>(0);
  const [stock, setStock] = useState<number>(0);
  const [cost, setCost] = useState<number>(0);

  const addProduct = () => {
    const newProduct: Product = {
      id: Date.now(),
      name,
      price,
      stock,
      cost,
      barcode: '',
      minStockThreshold: 0,
      isActive: true,
      categoryId: 0
    };
    setProducts([...products, newProduct]);
    setName("");
    setPrice(0);
    setStock(0);
    setCost(0);
  };

  return (
    <div>
      <h2>🛒 Gestión de Productos</h2>
      <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nombre" />
      <input type="number" value={price} onChange={(e) => setPrice(Number(e.target.value))} placeholder="Precio" />
      <input type="number" value={stock} onChange={(e) => setStock(Number(e.target.value))} placeholder="Stock" />
      <input type="number" value={cost} onChange={(e) => setCost(Number(e.target.value))} placeholder="Costo" />
      <button onClick={addProduct}>Agregar</button>

      <ul>
        {products.map((p) => (
          <li key={p.id}>
            {p.name} - ${p.price} (Stock: {p.stock}, Costo: {p.cost})
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Products;
